import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../uicomponentcss';

export interface VerticalListCSSStyle extends UIComponentCSSStyle
{
    getListRowCSSStyle(): object;
}

export class VerticalListCSSStyleImpl extends UIComponentCSSStyleImpl implements VerticalListCSSStyle
{
    getWrapperCSSStyle(): object
    {
        return {
            listStyleType: "none",
            width: "100%",
            height: "100%",
            display: "flex",
            flexFlow: "row wrap"
        };
    }
    
    getListRowCSSStyle(): object 
    {
        return {
            width: '100%', 
            display: 'flex', 
            alignItems: 'center', 
            marginTop: "20px",
            justifyContent: 'flex-start', 
            borderRadius: '8px'
        };
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/verticallist/verticallistcss.tsx